import * as React from 'react';
import { SVGProps } from 'react';

const IconReplySizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m12 5.5-5-4V4C3 4 1 5.5 1 7.5 1 9 1.5 10 3 11c-.367-1.1-1-4 4-4v2.5l5-4z" />
  </svg>
);
export default IconReplySizeXs;
